// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"Scrollbar_scrollbar__2AXZT","style15":"Scrollbar_style15__1APsz"};